import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { GET_MERCHANT_PARTNERS } from 'router/queries'
import { useSession } from 'packages/@slerp/accounts'
import { useLazyQuery } from '@apollo/client'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { MerchantIntegration } from '@slerp/controls'

export const MerchantIntegrationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const { integrations, setIntegrations, setRefetchIntegrations } =
    useMerchant()

  const [isLoaded, setIsLoaded] = useState(false)

  const [getMerchantIntegrations, { data, loading, refetch }] = useLazyQuery<{
    partners_merchants: MerchantIntegration[]
  }>(GET_MERCHANT_PARTNERS, {
    variables: { merchantId: merchant?.id }
  })

  useEffect(() => {
    if (!merchant?.id || integrations?.length > 0) {
      return
    }

    getMerchantIntegrations()
  }, [merchant?.id])

  useEffect(() => {
    if (!refetch) {
      return
    }

    setRefetchIntegrations(() => refetch)
  }, [refetch])

  useEffect(() => {
    if (data?.partners_merchants) {
      setIntegrations(data.partners_merchants)
    }
  }, [data])

  useEffect(() => {
    setIsLoaded(isParentLoaded && !loading)
  }, [loading, isParentLoaded])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
